module.exports = __webpack_public_path__ + "img/iconHistoryMaterial.8f3fb76f.svg";